export type TrainSubview = "overview" | "timeline" | "analysis";

export type TrainSubviewEvent = "open-overview" | "open-timeline" | "open-analysis" | "parse-success";

export function reduceTrainSubview(current: TrainSubview, event: TrainSubviewEvent): TrainSubview {
  if (event === "open-overview") {
    return "overview";
  }

  if (event === "open-timeline") {
    return "timeline";
  }

  if (event === "open-analysis" || event === "parse-success") {
    return "analysis";
  }

  return current;
}
